export default "__VITE_ASSET__48a5cd58__"